import React from 'react';

import Tooltip from 'antd/es/tooltip';

import colors from 'config/colors';

import Table from 'components/Table';
import { Text } from 'components/Text';
import { EQUIPMENT_TYPE_LABELS, isContainer, isTrailer } from 'helpers/process';

const DoorActivityTable = ({ isLoading, onEmployeesLinkClicked, showIndividuals, ...props }) => (
  <Table
    loading={isLoading}
    rowKey='container_code'
    {...props}
  >
    <Table.Column type="link" title="Equipment Code" dataIndex="container_code" to={({ item }) => {
      if (isTrailer(item)) return `/trailers/${item.container_id}`;
      if (isContainer(item)) return `/containers/${item.container_id}`;
    }} />
    <Table.Column type="text" title="Type" dataIndex="container_type" render={(containerType) => {
      return EQUIPMENT_TYPE_LABELS[containerType] || '-';
    }} />
    <Table.Column type="datetime" title="Docked" dataIndex="docked_at" tzOffset="timezone_offset" />
    <Table.Column type="duration" title="Idle Time Before" dataIndex="dock_start_iddle" align="center" withSecs={false} />
    <Table.Column type="duration" title="Unload/Load Time" dataIndex="unload_duration" align="center" withSecs={false} />
    <Table.Column type="duration" title="Idle Time After" dataIndex="dock_end_iddle" align="center" withSecs={false} />
    <Table.Column type="datetime" title="Undocked" dataIndex="undocked_at" tzOffset="timezone_offset" />
    <Table.Column type="number" title="Cartons" dataIndex="unloaded_boxes" align="right" rounded={true} />
    <Table.Column type="number" title="CPH" dataIndex="cph" align="right" rounded={true} />
    {showIndividuals && (
      <Table.Column title="Individuals" dataIndex="employees" align="right" render={(employees = [], item) => {
        if (!employees || !employees.length) {
          return <Text style={{ color: colors.primary }}>0</Text>;
        }
        return (
          <Tooltip placement="top" title={employees.length ? employees.map((e, i) =>
            <span key={i}>{e.full_name}<br /></span>
          ) : 'No individuals'} trigger="hover">
            <Text onClick={() => onEmployeesLinkClicked(item)} style={{ color: colors.primary, cursor: 'pointer' }}>
              {employees.length}
            </Text>
          </Tooltip>
        );
      }} />
    )}
  </Table>
);

export default DoorActivityTable;
